/**
 * @generated SignedSource<<910c5e5248c8ccc96e72d7741781fdbf>>
 * @relayHash 43ff09dccb1bb3644584f9b4ba7804c0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6d75156230fd505bd9900223bfe1ed77c1f2bc9d9d52ca9828480993a81ea725

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "6d75156230fd505bd9900223bfe1ed77c1f2bc9d9d52ca9828480993a81ea725",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
